import { msg } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { useIsStaff } from '@web/containers/Timesheets/hooks';

export function useActionBarTitle() {
  const isStaff = useIsStaff();
  const { _ } = useLingui();
  return _(isStaff ? msg`Staff timesheet` : msg`My timesheet`);
}
